/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const wasteType = async (): Promise<any> => {
  const wasteType = useJSONStore.getState().wasteType;
  const token = useUserStore.getState().userToken;
  const setWasteType = useJSONStore.getState().setWasteType;

  if (wasteType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.wasteType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setWasteType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default wasteType;
